import * as mqtt from "mqtt";
import autobind from "autobind-decorator";
import { FpId } from "./FpId";
import { AppState, PresenceStore, PresenceState } from "./stores";
import { setInterval } from "timers";
import { observable, reaction } from "mobx";

export enum MqttState {
	CONNECTING,
	ONLINE,
	OFFLINE,
}

export class MqttClient {
	public client: mqtt.MqttClient;

	@observable public state: MqttState = MqttState.OFFLINE;

	constructor(
		private appState: AppState,
		private presenceStore: PresenceStore,
	) {}

	public connect() {
		if (this.client) {
			this.end();
		}

		this.state = MqttState.CONNECTING;

		this.client = mqtt.connect(`wss://${window.location.host}/mqtt`, {
			keepalive: 30,
			clientId: FpId.new(), // TODO: we should get this from the server
			clean: false,
			// set the presence offline as our last will
			will: {
				topic: `dscid/${this.appState.dscid}/presence/dscaid/${this.appState.dscaid}`,
				payload: JSON.stringify({
					apiVersion: "presence/v1",
					type: "setPresence",
					data: {
						presence: PresenceState.OFFLINE,
						note: ""
					},
				}),
				qos: 0,
				retain: false,
			}
		});

		this.client.subscribe(`dscid/${this.appState.dscid}/presence/state`);
		this.client.subscribe(`dscid/${this.appState.dscid}/presence/event`);

		this.client.on("connect", () => this.state = MqttState.ONLINE);
		this.client.on("offline", () => this.state = MqttState.OFFLINE);
		this.client.on("close", () => this.state = MqttState.OFFLINE);

		this.client.on("message", this.handleMessage);

		// ping server every 30 seconds with our presence
		this.sendPresence();
		setInterval(this.sendPresence, 30 * 1000);
		// ... or if our note changes
		reaction(
			() => this.presenceStore.myNote,
			() => this.sendPresence(),
			{ delay: 3000 }
		);
	}

	public end() {
		this.client.end();
		this.client = null;
	}

	@autobind
	private sendPresence() {
		this.client.publish(`dscid/${this.appState.dscid}/presence/dscaid/${this.appState.dscaid}`, JSON.stringify({
			apiVersion: "presence/v1",
			type: "setPresence",
			data: {
				presence: PresenceState.ONLINE,
				note: ""
			},
		}));
	}

	@autobind
	private handleMessage(topic: string, payload: Buffer) {
		let msg = JSON.parse(payload.toString());

		switch (msg.apiVersion) {
			case "presence/v1": this.presenceStore.handleMqttMessage(topic, msg); break;
			default: console.log("unknown MQTT:", topic, msg.apiVersion, msg.type); break;
		}
	}
}




// WEBPACK FOOTER //
// ./src/lib/MqttClient.ts